import clsx from 'clsx';
import React, { ReactNode } from 'react';

import Icon, { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';

export const STATUS_ICON_PREFIX = 'status-icon';

type StatusIcons = 'active_file' | 'close_file' | 'email_open' | 'email' | 'outbound';

type StatusIconProps = {
  icon: StatusIcons;
  containerClassName?: null | string;
  svgProps?: {
    className: string;
    [key: string]: any;
  };
  iconClassName?: null | string;
  iconType?: keyof typeof ICON_TYPES;
  children?: ReactNode;
};

const StatusIcon = ({
  icon,
  containerClassName = null,
  svgProps = null,
  iconClassName = null,
  iconType = 'filled',
  children = null,
}: StatusIconProps) => {
  const iconValue = ICONS[icon];

  const myIcon = typeof iconValue === 'function' ? iconValue(svgProps) : iconValue;
  const myIconType = ICON_TYPES[iconType];

  return (
    <span
      className={clsx(
        'tw-flex tw-items-center',
        'tw-rounded-[34px]',
        'tw-bg-cfo-grey-100',
        containerClassName
      )}
      data-testid={`${STATUS_ICON_PREFIX}-${icon}`}
    >
      <Icon
        icon={myIcon}
        className={clsx(' tw-text-[18px]', iconClassName)}
        iconType={myIconType}
      />
      {children}
    </span>
  );
};

export default StatusIcon;
